module.exports = __webpack_public_path__ + "img/venezuela.e21e0b23.png";